import moment from "moment";
import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";

import { getDisablePreviousDates, getButtonBgColor, getFontFamily } from "slices";

const YearShow = ({ onClickYear }) => {
  const disablePreviousDates = useSelector(getDisablePreviousDates);
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);

  const currentYearRef = useRef();

  const years = Array.from({ length: 200 }, (_, i) => 1900 + i);

  useEffect(() => {
    if (currentYearRef.current) {
      currentYearRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, []);

  return (
    <div className="hayley-col-span-7 hayley-grid hayley-max-h-[240px] hayley-grid-cols-4 hayley-gap-y-2 hayley-overflow-y-auto">
      {years.map((year, i) => (
        <Button
          key={i}
          className={`hayley-custom hayley-flex hayley-h-12 hayley-min-h-fit hayley-w-full hayley-min-w-fit hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-rounded-none hayley-border hayley-border-solid hayley-border-transparent hayley-font-opensans hayley-text-sm hayley-font-semibold hayley-text-secondary disabled:hayley-cursor-not-allowed disabled:hayley-text-secondary/40 disabled:hover:hayley-text-secondary/40 ${
            moment().year() === year ? "hayley-bg-secondary/10" : "hayley-bg-white"
          }`}
          sx={{
            "&.hayley-custom": {
              fontFamily: `${fontFamily} !important`,
              "&:hover": { borderColor: `${color} !important` },
            },
          }}
          onClick={() => onClickYear(year)}
          disabled={disablePreviousDates && year < moment().year()}
          ref={moment().year() === year ? currentYearRef : null}
        >
          {year}
        </Button>
      ))}
    </div>
  );
};

export default YearShow;
